import React from 'react';
import Carousel from 'react-bootstrap/Carousel';
import { loginCarousel } from './constants';
import { BnyLogo } from '../../../styles/svg/svgIcons';

export default class LoginCarousel extends React.Component {
  render() {
    return (
      <Carousel className="login-carousel">
        {loginCarousel.map((carousel) => {
          return (
            <Carousel.Item key={carousel.title}>
              <Carousel.Caption>
                <div>
                  <div className="m-auto w-180px login-logo-wrapper">
                    <BnyLogo />
                  </div>
                </div>
                <div className="img-wrap mt-5">
                  <img src={carousel.icon} alt="data science" />
                </div>
                <div>
                  <span className="image-title mb-2 d-inline-block mt-3 font-weight-600">
                    {carousel.title}
                  </span>

                  <p className="image-description f-18">{carousel?.description}</p>
                  <div className="f-14 text-black mt-3">Powered By</div>
                  <h3 className="f-28 text-black">FinOptSys</h3>
                </div>
              </Carousel.Caption>
            </Carousel.Item>
          );
        })}
      </Carousel>
    );
  }
}
